var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.52778 6.05555C4.92384 6.05555 6.05556 4.92383 6.05556 3.52778C6.05556 2.13172 4.92384 1 3.52778 1C2.13172 1 1 2.13172 1 3.52778C1 4.92383 2.13172 6.05555 3.52778 6.05555Z",
    stroke: "#426CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4731 6.05555C12.8691 6.05555 14.0009 4.92383 14.0009 3.52778C14.0009 2.13172 12.8691 1 11.4731 1C10.077 1 8.94531 2.13172 8.94531 3.52778C8.94531 4.92383 10.077 6.05555 11.4731 6.05555Z",
    stroke: "#426CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.52778 14.0009C4.92384 14.0009 6.05556 12.8691 6.05556 11.4731C6.05556 10.077 4.92384 8.94531 3.52778 8.94531C2.13172 8.94531 1 10.077 1 11.4731C1 12.8691 2.13172 14.0009 3.52778 14.0009Z",
    stroke: "#426CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4731 14.0009C12.8691 14.0009 14.0009 12.8691 14.0009 11.4731C14.0009 10.077 12.8691 8.94531 11.4731 8.94531C10.077 8.94531 8.94531 10.077 8.94531 11.4731C8.94531 12.8691 10.077 14.0009 11.4731 14.0009Z",
    stroke: "#426CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dash_Icon.6d6a862f461ad4a9e2087330c1cbe559.svg";
export { ForwardRef as ReactComponent };